// extracted by css-extract-rspack-plugin
export default {"textarea":"MemoForm__textarea--taQfj","form":"MemoForm__form--Y7LBR","searchContainer":"MemoForm__searchContainer--cEz7A"};